module.exports = __webpack_public_path__ + "static/media/29ADMSPC12.c138cf7a.jpg";